import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import green from "@material-ui/core/colors/green";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";

toastr.options = {
  closeButton: true,
};

export class AddCategoryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // categoryFormContent: props.location && props.location.state && props.location.state.categoryUnderView ? props.location.state.categoryUnderView : addCategoryForm,
      userData: null,
      familyData: null,
    };
  }
  componentWillMount = () => {
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data && data.token) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }

    if (
      this.props &&
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.state &&
      this.props.history.location.state.data
    ) {
      let userData = this.props.history.location.state.data;
      axios
        .get(`${domain}/user/find/family/members/${userData._id}`, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            // toastr.success("Question Updated Successfully!")
            // this.props.history.goBack();
            this.setState({
              familyData: res.data.data,
            });
          }
        })
        .catch((error) => {});

      this.setState({
        userData,
      });
    }
  };

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      {
        Header: "Profile",
        Cell: (props) => {
          return (
            <img
              className={props.original.profile_pic ? "profile_pic" : null}
              src={props.original.profile_pic}
            />
          );
        },
      },
      {
        Header: "First",
        accessor: "first_name",
      },
      {
        Header: "Middle",
        accessor: "middle_name",
      },
      {
        Header: "Last",
        accessor: "last_name",
      },
      {
        Header: "Suffix",
        accessor: "suffix",
      },
      {
        Header: "Bermudian",
        Cell: (props) => {
          return (
            <span>
              {props.original.bermudian ? "Resident" : "non-Resident"}
            </span>
          );
        },
      },
      {
        Header: "Birth Date",
        accessor: "dob",
      },

      {
        Header: "Gender",
        accessor: "gender",
      },
      {
        Header: "Address",
        width: 300,
        className: "wrap_column",
        Cell: (props) => {
          return (
            <span>
              {props.original.address && props.original.address.length > 0
                ? props.original.address[0].street_address +
                  ", " +
                  props.original.address[0].landmark +
                  ", " +
                  props.original.address[0].country +
                  ", " +
                  props.original.address[0].zip_code
                : " "}
            </span>
          );
        },
      },
    ];
    return column;
  };

  render() {
    const { classes } = this.props;
    let { userData, familyData } = this.state;
    return (
      <div className="add-category-form">
        <Card>
          <CardContent>
            <GridContainer>
              <GridItem xs={12}>
                {userData.profile_pic ? (
                  <img
                    className="profile_pic view_main"
                    src={userData.profile_pic}
                  />
                ) : null}
                <TextField
                  autoFocus
                  margin="dense"
                  id="username"
                  label="UserName"
                  type="username"
                  fullWidth
                  value={userData.user_name ? userData.user_name : ""}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Prefix"
                  type="name"
                  fullWidth
                  value={userData.prefix ? userData.prefix : ""}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="First"
                  type="name"
                  fullWidth
                  value={userData.first_name ? userData.first_name : ""}
                  style={{ marginBottom: "20px" }}
                />

                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Middle"
                  type="name"
                  fullWidth
                  value={userData.middle_name ? userData.middle_name : ""}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Last"
                  type="name"
                  fullWidth
                  value={userData.last_name ? userData.last_name : ""}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Suffix"
                  type="name"
                  fullWidth
                  value={userData.suffix ? userData.suffix : ""}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Bermudian"
                  type="name"
                  fullWidth
                  value={userData.bermudian ? "Resident" : "Non-Resident"}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Birth of Date"
                  type="name"
                  fullWidth
                  value={userData.dob ? userData.dob : ""}
                  style={{ marginBottom: "20px" }}
                />

                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Gender"
                  type="name"
                  fullWidth
                  value={userData.gender ? userData.gender : ""}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Email Address"
                  type="name"
                  fullWidth
                  value={userData.email ? userData.email : ""}
                  style={{ marginBottom: "20px" }}
                />

                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Phone"
                  type="name"
                  fullWidth
                  value={userData.phone ? userData.phone : ""}
                  style={{ marginBottom: "20px" }}
                />

                {userData.address && userData.address.length > 0 ? (
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Address"
                    type="name"
                    fullWidth
                    value={
                      userData.address && userData.address.length > 0
                        ? userData.address[0].street_address +
                          ", " +
                          userData.address[0].landmark +
                          ", " +
                          userData.address[0].country +
                          ", " +
                          userData.address[0].zip_code
                        : " "
                    }
                    style={{ marginBottom: "20px" }}
                  />
                ) : null}

                <h4>Household Members</h4>
                <ReactTable
                  data={familyData ? familyData : []}
                  columns={this.getUserTableColumn()}
                  defaultPageSize={20}
                  pageSizeOptions={[5, 10, 20, 25, 50]}
                  showPaginationBottom={true}
                  minRows={4}
                  // manual
                  noDataText="No Family Member found"
                  onPageChange={(pageIndex) => {}}
                  onPageSizeChange={(rowPerPage) => {}}
                />
                <FormControlLabel
                  control={
                    <Switch
                      className={
                        userData.status == "active"
                          ? "main_switch_btns toggle_active"
                          : "main_switch_btns toggle_inactive"
                      }
                      checked={userData.status == "active" ? true : false}
                      onChange={(e) => {
                        e.stopPropagation();
                        let state = !userData.status;
                        let id = userData._id;
                        let body = {
                          id: id,
                        };
                        if (userData.status == "active") {
                          body.status = "disable";
                        } else {
                          body.status = "active";
                        }
                        let data = JSON.parse(
                          localStorage.getItem("BerPay_Admin")
                        );
                        let config = {};
                        if (data && data.token) {
                          config = {
                            headers: { Authorization: `Bearer ${data.token}` },
                          };
                        }

                        axios
                          .put(`${domain}/user/update/appuser`, body, config)
                          .then((res) => {
                            if (
                              res.data.statusCode === 200 ||
                              res.data.statusCode === 201
                            ) {
                              if (userData.status == "active") {
                                toastr.success("User Blocked Successfully!");
                              } else {
                                toastr.success("User Unblocked Successfully!");
                              }
                              this.props.history.goBack();
                            }
                          })
                          .catch((error) => {});
                      }}
                      color="primary"
                      name="active"
                      inputProps={{ "aria-label": "primary checkbox" }}
                      l
                    />
                  }
                  label="Block/Unblock"
                />
              </GridItem>
            </GridContainer>
          </CardContent>

          {/* <CardActions style={{ float: 'right' }}>
            <Button variant="contained" color="primary" onClick={this.submitForm}>
              Submit
            </Button>
          </CardActions> */}
        </Card>
      </div>
    );
  }
}

export default AddCategoryForm;
